module.exports = __webpack_public_path__ + "static/media/Long covid.96dffd99.webp";